import { TagTreeNode } from '@/components/ui/tag-tree-selector';
import { TvController } from '@/lib/schema/tvController';
import {
  flattenGroups,
  TvControllerGroup,
} from '@/lib/schema/tvControllerGroup';

/** Tags present on TVs that no group points at (e.g. typed in the TV form). */
export function ungroupedTags(
  groups: TvControllerGroup[],
  tvControllers: TvController[] | undefined
): string[] {
  const grouped = new Set(flattenGroups(groups).map((group) => group.tag));
  return Array.from(
    new Set((tvControllers || []).flatMap((tv) => tv?.tags || []))
  )
    .filter((tag) => !grouped.has(tag))
    .sort();
}

/** Group tree → selector tree, with unplaced tags under "Ungrouped" so a tag
 *  is never hidden from the filter. */
export function toTagTree(
  groups: TvControllerGroup[],
  ungrouped: string[]
): TagTreeNode[] {
  const convert = (group: TvControllerGroup): TagTreeNode => ({
    id: group.id,
    label: group.name,
    tag: group.tag,
    children: group.children.map(convert),
  });
  const tree = groups.map(convert);
  if (ungrouped.length) {
    tree.push({
      id: 'ungrouped',
      label: 'Ungrouped',
      children: ungrouped.map((tag) => ({
        id: `ungrouped:${tag}`,
        label: tag,
        tag,
      })),
    });
  }
  return tree;
}
